<script>
export default {
  name: "VitaView",
  data() {
    return {
      lifeEvents: [
        {
          year: "1181/1182",
          title: "Nascita",
          description: "Francesco nasce ad Assisi da Pietro di Bernardone e Pica"
        },
        {
          year: "1202",
          title: "Guerra e Prigionia",
          description: "Partecipa alla guerra tra Assisi e Perugia, viene fatto prigioniero"
        },
        {
          year: "1205",
          title: "Crisi Spirituale",
          description: "Dopo una malattia, inizia a interrogarsi sul senso della vita"
        },
        {
          year: "1206",
          title: "Conversione",
          description: "Rinuncia pubblicamente ai beni paterni davanti al vescovo di Assisi"
        },
        {
          year: "1208",
          title: "Vocazione",
          description: "Ascolta il Vangelo e decide di vivere in povertà assoluta"
        },
        {
          year: "1209",
          title: "Primi Compagni",
          description: "Si uniscono a lui i primi fratelli, nasce l'ordine francescano"
        },
        {
          year: "1223",
          title: "Regola",
          description: "Il Papa approva la Regola dell'Ordine dei Frati Minori"
        },
        {
          year: "1224",
          title: "Stimmate",
          description: "Riceve le stimmate sul monte della Verna"
        },
        {
          year: "1226",
          title: "Morte",
          description: "Muore alla Porziuncola, vicino ad Assisi, il 3 ottobre"
        }
      ]
    }
  }
}
</script>

<template>
  <h1 style="color: #fb4242">La Vita di San Francesco d'Assisi</h1>
  <hr class="linea-ancore-primo-livello">
  
  <div class="vita-intro">
    <p>
      Francesco nacque ad Assisi tra il 1181 e il 1182, figlio di un ricco mercante di stoffe. 
      La sua giovinezza fu spensierata e agiata, ma un'esperienza di guerra e malattia 
      lo portò a una profonda crisi spirituale che cambiò radicalmente la sua vita.
    </p>
  </div>
  
  <div class="arrow-spacer">
    <i class="fa fa-arrow-down"></i>
  </div>
  
  <h2 style="color: white">Tappe Fondamentali</h2>
  
  <div class="timeline">
    <div class="timeline-item" v-for="event in lifeEvents" :key="event.year">
      <div class="timeline-marker"></div>
      <div class="timeline-content">
        <h3 class="timeline-year">{{ event.year }}</h3>
        <h4 class="timeline-title">{{ event.title }}</h4>
        <p class="timeline-description">{{ event.description }}</p>
      </div>
    </div>
  </div>
  
  <div class="arrow-spacer">
    <i class="fa fa-arrow-down"></i>
  </div>
  
  <div class="legacy-section">
    <h2 style="color: white">L'Eredità di Francesco</h2>
    <div class="legacy-grid">
      <div class="legacy-card">
        <h3>Ordine Francescano</h3>
        <p>L'ordine fondato da Francesco conta oggi milioni di seguaci in tutto il mondo</p>
      </div>
      <div class="legacy-card">
        <h3>Messaggio di Pace</h3>
        <p>Il suo messaggio di pace e fratellanza universale è ancora attuale</p>
      </div>
      <div class="legacy-card">
        <h3>Ecologia Integrale</h3>
        <p>La sua visione del creato ispira la moderna sensibilità ecologica</p>
      </div>
      <div class="legacy-card">
        <h3>Povertà Evangelica</h3>
        <p>L'esempio di vita povera e umile continua a ispirare milioni di persone</p>
      </div>
    </div>
  </div>
  
  <div class="arrow-spacer">
    <i class="fa fa-arrow-down"></i>
  </div>
  
  <div class="resources-section">
    <h2 style="color: #fb4242; font-size: 2em;">Materiali di Approfondimento</h2>
    <p style="color: #dcdbdb; margin-bottom: 50px; font-size: 1.1em;">
      Esplora le nostre risorse didattiche per conoscere meglio la vita di San Francesco
    </p>
    
    <div class="resources-grid">
      <div class="resource-card presentation-card">
        <div class="resource-preview">
          <img src="@/assets/preview_francesco.png" alt="Preview Presentazione" />
          <div class="preview-overlay">
            <i class="fa fa-desktop"></i>
          </div>
        </div>
        <div class="resource-content">
          <h3>Presentazione</h3>
          <h4>San Francesco d'Assisi</h4>
          <p>Una presentazione completa e illustrata sulla vita e il messaggio spirituale di San Francesco</p>
          <div class="resource-meta">
            <span><i class="fa fa-file-powerpoint-o"></i> PowerPoint</span>
            <span><i class="fa fa-desktop"></i> Multimediale</span>
          </div>
        </div> 
        <div class="resource-actions">
          <a href="/San-francesco.pptx" target="_blank" class="resource-button primary-button">
            <i class="fa fa-eye"></i> Visualizza
          </a>
          <a href="/San-francesco.pptx" download class="resource-button secondary-button">
            <i class="fa fa-download"></i> Scarica
          </a>
        </div>
      </div>
      
      <div class="resource-card poster-card">
        <div class="resource-preview">
          <img src="@/assets/preview_cartellone.png" alt="Preview Cartellone" />
          <div class="preview-overlay">
            <i class="fa fa-newspaper"></i>
          </div>
        </div>
        <div class="resource-content">
          <h3>Cartellone</h3>
          <h4>Illustrato</h4>
          <p>Cartellone didattico colorato con le tappe fondamentali della vita di San Francesco</p>
          <div class="resource-meta">
            <span><i class="fa fa-file-pdf-o"></i> PDF</span>
            <span><i class="fa fa-picture-o"></i> Illustrato</span>
          </div>
        </div>
        <div class="resource-actions">
          <a href="/Cartellone.pdf" target="_blank" class="resource-button primary-button">
            <i class="fa fa-eye"></i> Visualizza
          </a>
          <a href="/Cartellone.pdf" download class="resource-button secondary-button">
            <i class="fa fa-download"></i> Scarica
          </a>
        </div>
      </div>
      
      <div class="resource-card quiz-card">
        <div class="resource-preview">
          <img src="@/assets/preview_quiz.png" alt="Preview Quiz" />
          <div class="preview-overlay quiz-overlay">
            <i class="fa fa-question-circle"></i>
          </div>
        </div>
        <div class="resource-content">
          <h3>Quiz Interattivo</h3>
          <h4>Sulla Vita di Francesco</h4>
          <p>Test interattivo online con domande per verificare la conoscenza della biografia francescana</p>
          <div class="resource-meta">
            <span><i class="fa fa-gamepad"></i> Interattivo</span>
            <span><i class="fa fa-graduation-cap"></i> Didattico</span>
          </div>
        </div>
        <div class="resource-actions">
          <router-link to="/quiz-vita" class="resource-button primary-button">
            <i class="fa fa-play-circle"></i> Inizia Quiz
          </router-link>
          <a href="/Vita_quiz.docx" download class="resource-button secondary-button">
            <i class="fa fa-download"></i> Scarica PDF
          </a>
        </div>
      </div>
      
      <div class="resource-card crossword-card">
        <div class="resource-preview">
          <img src="@/assets/preview_cruciverba.png" alt="Preview Cruciverba" />
          <div class="preview-overlay crossword-overlay">
            <i class="fa fa-th"></i>
          </div>
        </div>
        <div class="resource-content">
          <h3>Cruciverba Interattivo</h3>
          <h4>Sulla Vita di Francesco</h4>
          <p>Cruciverba interattivo online con domande per verificare la conoscenza della vita di San Francesco</p>
          <div class="resource-meta">
            <span><i class="fa fa-gamepad"></i> Interattivo</span>
            <span><i class="fa fa-graduation-cap"></i> Didattico</span>
          </div>
        </div>
        <div class="resource-actions">
          <router-link to="/cruciverba-vita" class="resource-button primary-button">
            <i class="fa fa-play-circle"></i> Gioca Online
          </router-link>
          <a href="/Cruciverba-vita.pdf.pdf" download class="resource-button secondary-button">
            <i class="fa fa-download"></i> Scarica PDF
          </a>
        </div>
      </div>
    </div>
  </div>
  
  <div style="margin-top: 200px; height: 1px;"></div>
</template>

<style scoped>
hr.linea-ancore-primo-livello {
  width: 40%;
  border-top: 2px solid #eee;
  margin: 20px auto 40px auto;
}

.vita-intro {
  max-width: 800px;
  margin: 40px auto;
  padding: 30px;
  background: #181a1c;
  border-radius: 10px;
  font-size: 1.1em;
}

.arrow-spacer {
  margin: 60px 0;
  color: white;
  font-size: 1.5em;
}

.timeline {
  max-width: 800px;
  margin: 40px auto;
  position: relative;
  padding: 20px 0;
}

.timeline::before {
  content: '';
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 2px;
  height: 100%;
  background: #fb4242;
}

.timeline-item {
  display: flex;
  justify-content: flex-start;
  padding: 20px 0;
  position: relative;
}

.timeline-item:nth-child(even) {
  justify-content: flex-end;
}

.timeline-marker {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 16px;
  height: 16px;
  background: #fb4242;
  border: 3px solid #131517;
  border-radius: 50%;
  z-index: 1;
}

.timeline-content {
  width: 45%;
  background: #181a1c;
  padding: 20px;
  border-radius: 8px;
  transition: transform 0.3s;
}

.timeline-content:hover {
  transform: scale(1.05);
}

.timeline-item:nth-child(even) .timeline-content {
  text-align: right;
}

.timeline-year {
  color: #fb4242;
  font-size: 1.2em;
  margin: 0 0 10px 0;
}

.timeline-title {
  color: white;
  margin: 0 0 10px 0;
}

.timeline-description {
  color: #9f9d9d;
  margin: 0;
}

.legacy-section {
  margin: 60px auto;
  max-width: 1000px;
}

.legacy-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 20px;
  margin: 40px 0;
}

.legacy-card {
  background: #181a1c;
  padding: 30px;
  border-radius: 10px;
  transition: transform 0.3s, box-shadow 0.3s;
}

.legacy-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 10px 20px rgba(251, 66, 66, 0.3);
}

.legacy-card h3 {
  color: white;
  margin-top: 0;
}

.legacy-card p {
  color: #9f9d9d;
}

@media (max-width: 768px) {
  .timeline::before {
    left: 20px;
  }
  
  .timeline-marker {
    left: 20px;
  }
  
  .timeline-content {
    width: calc(100% - 60px);
    margin-left: 60px;
  }
  
  .timeline-item:nth-child(even) .timeline-content {
    text-align: left;
  }
}

.resources-section {
  max-width: 1400px;
  margin: 80px auto;
  padding: 60px 20px;
  background: linear-gradient(135deg, rgba(24, 26, 28, 0.8) 0%, rgba(31, 33, 35, 0.8) 100%);
  border-radius: 20px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
}

.resources-section h2 {
  text-align: center;
  margin-bottom: 10px;
}

.resources-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
  margin: 50px 0;
}

.resource-card {
  background: #1f2123;
  border-radius: 15px;
  padding: 0;
  transition: all 0.4s ease;
  overflow: hidden;
  border: 2px solid transparent;
  display: flex;
  flex-direction: column;
  position: relative;
}

.resource-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 5px;
  background: linear-gradient(90deg, #fb4242, #ff6b6b);
  transform: scaleX(0);
  transition: transform 0.4s ease;
}

.resource-card:hover::before {
  transform: scaleX(1);
}

.resource-card:hover {
  transform: translateY(-15px);
  box-shadow: 0 20px 50px rgba(251, 66, 66, 0.4);
  border-color: #fb4242;
}

.presentation-card:hover { border-color: #ff6b6b; }
.poster-card:hover { border-color: #4ecdc4; }
.quiz-card:hover { border-color: #ffd93d; }
.crossword-card:hover { border-color: #95e1d3; }

.resource-preview {
  position: relative;
  width: 100%;
  height: 200px;
  overflow: hidden;
  background: #0d0e0f;
}

.resource-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s ease, filter 0.4s ease;
}

.resource-card:hover .resource-preview img {
  transform: scale(1.1);
  filter: brightness(0.7);
}

.preview-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(251, 66, 66, 0.8), rgba(251, 66, 66, 0.3));
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.4s ease;
}

.resource-card:hover .preview-overlay {
  opacity: 1;
}

.preview-overlay i {
  font-size: 4em;
  color: white;
  transform: scale(0.5);
  transition: transform 0.4s ease;
}

.resource-card:hover .preview-overlay i {
  transform: scale(1);
}

.quiz-overlay {
  background: linear-gradient(135deg, rgba(255, 217, 61, 0.9), rgba(255, 217, 61, 0.4));
}

.crossword-overlay {
  background: linear-gradient(135deg, rgba(149, 225, 211, 0.9), rgba(149, 225, 211, 0.4));
}

.resource-icon-large {
  padding: 40px;
  text-align: center;
  background: linear-gradient(135deg, rgba(251, 66, 66, 0.1), rgba(251, 66, 66, 0.05));
  border-bottom: 1px solid rgba(251, 66, 66, 0.2);
}

.resource-icon-large i {
  font-size: 4em;
  color: #fb4242;
  transition: transform 0.3s ease;
}

.resource-card:hover .resource-icon-large i {
  transform: scale(1.2) rotate(5deg);
}

.resource-content {
  padding: 30px;
  flex-grow: 1;
  text-align: center;
}

.resource-content h3 {
  color: #fb4242;
  font-size: 1.5em;
  margin: 0 0 5px 0;
  font-weight: bold;
}

.resource-content h4 {
  color: #dcdbdb;
  font-size: 1.1em;
  margin: 0 0 15px 0;
  font-weight: normal;
  opacity: 0.8;
}

.resource-content p {
  color: #9f9d9d;
  line-height: 1.7;
  margin: 15px 0;
  font-size: 0.95em;
}

.resource-meta {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
  flex-wrap: wrap;
}

.resource-meta span {
  color: #fb4242;
  font-size: 0.85em;
  padding: 5px 12px;
  background: rgba(251, 66, 66, 0.1);
  border-radius: 15px;
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.resource-actions {
  display: flex;
  gap: 0;
  width: 100%;
  border-top: 1px solid rgba(251, 66, 66, 0.1);
}

.resource-button {
  flex: 1;
  padding: 18px 20px;
  text-decoration: none;
  font-weight: bold;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  border: none;
  font-size: 1em;
  text-align: center;
}

.primary-button {
  background: #fb4242;
  color: white;
  border-right: 1px solid rgba(255, 255, 255, 0.1);
}

.primary-button:hover {
  background: #ff5252;
  transform: scale(1.02);
}

.secondary-button {
  background: transparent;
  color: #fb4242;
}

.secondary-button:hover {
  background: rgba(251, 66, 66, 0.1);
  color: #ff5252;
}

.resources-note {
  text-align: center;
  margin-top: 40px;
  padding: 20px;
  background: rgba(251, 66, 66, 0.05);
  border-radius: 10px;
  color: #dcdbdb;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-size: 0.95em;
}

.resources-note i {
  color: #fb4242;
  font-size: 1.3em;
}

@media (max-width: 768px) {
  .resources-grid {
    grid-template-columns: 1fr;
  }
  
  .resource-button {
    font-size: 0.9em;
    padding: 15px;
  }
  
  .resources-section {
    padding: 40px 15px;
  }
}
</style>
